// CANONICAL COPY (GH #7115). src/constants/obligations/obl-policy-defined.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-policy-defined',
  title: 'Verify information security policy is defined and approved',
  description:
    'Confirm that the organisation has a published, management-approved information security policy that is communicated to all relevant personnel.',
  category: 'governance',
  scfIds: ['SCF-GOV-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'A published policy document covers these controls',
    },
    { type: 'document-approved', description: 'The policy has been approved' },
    {
      type: 'document-acknowledged',
      description: 'All required readers have acknowledged the policy',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
